<template>
    <div class="container container--catalog">

        <Loader v-if="!isReady"></Loader>
            
        <List v-else class="list--products"
            :filtering="this"
            :itemNameSingular="'article'"
            :itemNamePlural="'articles'" >

            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
        
            </template>

            <template v-slot:filters>
                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher dans mes tarifs négociés"/>
                </ListFilter>
                <ListFilter>
                    <Select v-model="filters.liste_id"
                        :options="listes"
                        all="Tous mes tarifs négociés">
                    </Select>
                </ListFilter>                
            </template>

            <template v-slot:checkboxActions>
                <button class="woocommerce-button button alt"
                    :disabled="processing || !itemSelected"
                    v-on:click="buy()">
                    <span class="fa fa-shopping-cart"></span>
                    Ajouter au panier
                </button>
            </template>

            <template v-slot:heading>                
                <div class="cell cell--cb">
                    <TogglerAll />
                </div>
                <div class="cell cell--ref">Réf.</div>
                <div class="cell cell--lists">Listes</div>
                <div class="cell cell--main">Produit</div>
                <div class="cell cell--variation">Unité de vente</div>
                <div class="cell cell--price">Prix HT</div>
                <div class="cell cell--actions">Actions</div>         
            </template>

            <ul class="list__content catalog" v-if="hasContent">

                <li v-for="category in categories"
                    :key="category.code">
                    
                    <collapse :hidden="false" :selected="true">

                        <div slot="collapse-header">

                            <div class="list__content__sublist">

                                <Category :data="category"/>

                            </div>
                        </div>


                        <div slot="collapse-body">                            
                            <ul class="list__content">

                                <li class="list__content__item"
                                    v-for="item in category.items"
                                    :key="item.id">

                                    <ArticleCatalog
                                        v-model="selectedItems"
                                        :data="item"
                                        :purchasable="item.isPurchasable"/>

                                </li>

                            </ul>
                        </div>
                    
                    </collapse>
                    
                </li>
                
            </ul>

            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun article</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les articles suivants</button>
            </div>           
        </List>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import api from '@/api/proxyWeb/catalog'
import { actions as listeActions } from '@/store/listes'

import ArticleCatalog from '@/components/articleCatalog/ArticleCatalog.vue'
import Button from '@/components/button/Button.vue'
import Category from '@/components/category/Category.vue'
import Collapse from '@/components/collapse/Collapse.vue'
import Loader from '@/components/loader/Loader.vue'
import List, { ListFilter, TogglerAll }  from '@/components/list/List.vue'
import Select  from '@/components/select/Select.vue'

import cart from '@/containers/cart.vue'
import selectAll from '@/containers/selectAll.vue'
import filtering from "@/containers/filtering";

import  { useCategories } from '@/helpers/category'

export default {

    name: 'Catalog',

    data: () => {
        return {
            filters: {
                liste_id: null,
                query: ''
            },
            uncategorizedItems: [],
            processingXlsx: false,
        }
    },

    computed: {

        categories: function() {
            return useCategories(this.items)
        },

        ...mapState({

            listes: function(state) {

                if ( !state.listes.all ) return []

                return state.listes.all.map(liste => {
                    return {
                        name : liste.libelle + ' Valide du ' + this.formatDate(liste.validiteStartAt) + ' au ' + this.formatDate(liste.validiteEndAt),
                        value: liste.id
                    }
                })
            }            
        })   
    },

    methods: {

        buy() {

            let articles = this.selectedItems.map(item => {
                    return {
                        'id': item.articleVariation.article.id,
                        'quantity': 1,
                        'variationId': item.articleVariation.id
                    }
                })

            this.addToCart(articles);
        },

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        },        

        formatDate: function(datetime) {
            return moment(datetime).format('DD/MM/YYYY')
        }    
    },
  
    created () {

        this.useFilter(api)

        Promise.all([
                this.$store.dispatch(listeActions.GET_ALL)
            ])
            .catch(error => {
                this.$errorPage(error.reason)
            })
    },

    watch:{

        'filters.liste_id': function() {
            this.selectableItems = []
        },

        items: function(items) {            

            this.selectableItems = []
            items.forEach(item => {
                if ( item.articleVariation.article.isAvailable && item.articleVariation.article.isActive ) {
                    this.selectableItems.push(item)
                }
            })
        }
    },

    components: {
        ArticleCatalog,
        Button,
        Category,
        Collapse,
        List,
        ListFilter,
        Loader,
        Select,
        TogglerAll
    },

    mixins: [
        cart,
        filtering,
        selectAll
    ]
}
</script>


<style scoped>

.catalog {
}

.catalog .catalog__filter {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
}

.catalog .catalog__filter > * {
    width: 30rem;
}

.cell.cell--ref {
    flex: 0.7;
}

.cell.cell--lists {
    flex: 1;
}
.cell.cell--variation {
    flex: 0.8;
}

.list__content__sublist {
    width: 100%;
}

</style>

<style>

.catalog .collapse .collapse-header::after {
  top: calc(50% - 0.2em);
}

</style>